// Status code
export const RESPONSE_SUCCESS_CODE = 200;
export const RESPONSE_INTERNAL_SERVER_ERROR_CODE = 520;
export const RESPONSE_NO_RECORDS_FOUND_CODE = 210;
export const RESPONSE_ATTACHED_SENSOR_CODE = 428;
export const RESPONSE_INVALID_SENSOR_CODE = 429;
export const RESPONSE_EXISTING_EQUIPMENT_NAME_CODE = 427;
export const RESPONSE_LOCATION_BLOCKED_CODE = 431 ;
export const RESPONSE_NO_S3_FILES_FOUND_CODE = 432;
export const RESPONSE_CATEGORY_NAME_TAKEN_CODE = 434;
export const RESPONSE_IN_USE_CATEGORY_CODE = 435;
export const RESPONSE_TEMPLATE_COMPONENTS_MISMATCH_CODE = 436;
export const RESPONSE_CATEGORY_JSON_ERROR = 437;
export const RESPONSE_ERROR_IN_CATEGORY_APPLY_CODE = 440;
export const RESPONSE_REPEATING_COMPONENT_TYPES_CODE = 441;
export const RESPONSE_REMOVE_CATEGORY_FAILED_CODE = 442;
export const RESPONSE_TYPE_VALIDATION_ERROR_CODE = 443;
export const RESPONSE_CATEGORY_UNAPPLIED_EQUIPMENT_UNITS_CODE = 444;
export const RESPONSE_COMPONENT_RENAME_FAILED_CODE = 445;
export const RESPONSE_EQUIPMENT_UNIT_RENAME_FAILED_CODE = 446;
export const RESPONSE_EQUIPMENT_RENAME_FAILED_CODE = 447;
export const RESPONSE_TEMPLATE_BEARING_COMBINATION_CODE = 448;
export const RESPONSE_CATEGORY_CREATED_COMPONENT_REVERT_CODE = 449;
export const RESPONSE_EXPIRED_JWT_TOKEN_CODE = 450;

export const REACT_TOAST_ACTION = {
    SUCCESS: "success",
    INFO: "info",
    ERROR: "error",
    WARNING: "warning",
    DARK: "dark",
    WARN: "warn"
}
export const IMAGE_OPTIONS_TYPE = ["EQUIPMENT", "COMPONENT"];
export const DEFAULT_EQUIPMENT_UNIT_NAME = "UNKNOWN";
export const UNKNOWN_BEARING_IDENTIFIER = "unknown";
export const SESSION_STORAGE_AUTH_KEY = "isAuthenticated";

export const useQueryConfiguration = {
    enabled: false, retry: false, retryOnMount: false,
    refetchOnMount: false, refetchOnWindowFocus: false
};

export const gloablSensorTableColumns = {
    "sensorId" : "Sensor",
    "sensorInstallLocation" : "Location",
    "componentName" : "Component",
    "equipmentUnitName" : "Equipment Unit",
    "equipmentName" : "Equipment",
    "profileName" : "Profile",
    "customerName" : "Customer",
    "modifiedBy" : "Last Modified By"
};

export const profileLevelSensorTableColumns = {
    "sensorId" : "Sensor",
    "sensorInstallLocation" : "Location",
    "componentName" : "Component",
    "equipmentUnitName" : "Equipment Unit",
    "equipmentName" : "Equipment",
    "modifiedBy" : "Last Modified By"
};

export const profileLevelBearingsTableColumns = {
    "bearingNumber": "bearing_number",
    "numBalls": "num_balls",
    "ballDiameter": "ball_diameter",
    "pitchDiameter": "pitch_diameter",
    "phi": "contact_angle",
    "ballPassFrequencyOuter": "bpfo",
    "ballPassFrequencyInner": "bpfi",
    "fundamentalTrainFrequency": "ftf",
    "ballSpinFrequency": "bsf",
    "rotatingInnerRace": "rotating_inner_race"
};